import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  IconLoader,
  PermissionDenied,
  PermissionEnum,
  Table,
  useScroll,
} from '@ui/src';
import { useAppSelector } from '@store';
import useList from './hooks/use-list';
import { newApplicationListColumnsLabels } from './variables/list';

import cn from './styles.module.css';

const ApplicationsList = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const { dictionariesIsLoading } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { newApplications, pagination, errorsList } = useAppSelector(
    (state) => state.newApplications.list,
  );
  const { newApplicationInfo } = useAppSelector(
    (state) => state.newApplications.individualInfo,
  );
  const { newApplicationInfo: newCorporateApplicationInfo } = useAppSelector(
    (state) => state.newApplications.corporateInfo,
  );
  const { newApplicationInfo: newMRApplicationInfo } = useAppSelector(
    (state) => state.newApplications.mainRepresentative,
  );
  const { userId } = useAppSelector((state) => state.root);
  const { countriesList: countries, activePermissions } = useAppSelector(
    (state) => state.root,
  );

  const { search } = useLocation();

  const {
    isFetching,
    isLoading,
    formattedColumns,
    formattedData,
    onSort,
    errorList,
    filters,
    sort,
    setSelectedSavedFilter,
    onFilter,
    filtersComponent,
    handleSubmit,
    selectedSavedFilter,
    setPage,
    savedFilters,
    setSavedFilters,
    onSavedFilterClick,
  } = useList({
    newApplications,
    countries,
    newApplicationInfo,
    newCorporateApplicationInfo,
    newMRApplicationInfo,
    userId,
    search,
  });

  useScroll({ element: scrollRef, requestInProgress: isFetching });

  let content: React.JSX.Element;

  if (isLoading || dictionariesIsLoading) {
    content = (
      <div className={cn.newApplicationLoader}>
        <IconLoader />
      </div>
    );
  } else if (
    !isLoading &&
    countries &&
    activePermissions?.includes(PermissionEnum.APPLICATIONS_CUSTOMERS_LIST)
  ) {
    content = (
      <Table
        title="New applications"
        columns={formattedColumns}
        data={formattedData || []}
        onSort={(name) => {
          onSort(name);
        }}
        error={errorsList || errorList}
        filters={filters}
        sort={sort}
        columnsLabels={newApplicationListColumnsLabels}
        onFilterChange={(values) => {
          setSelectedSavedFilter('');

          onFilter({ ...values });
        }}
        filtersComponent={filtersComponent}
        handleSubmit={handleSubmit}
        isLoading={isFetching}
        hiddedAllFilterTags={Boolean(selectedSavedFilter)}
        take="20"
        setPage={(data) => {
          setPage({ ...data, filters });
        }}
        savedFilters={savedFilters}
        setSavedFilters={setSavedFilters}
        savedFiltersKey="applications-filters"
        selectedSavedFilter={selectedSavedFilter}
        onSavedFilterClick={onSavedFilterClick}
        setSelectedSavedFilter={setSelectedSavedFilter}
        userId={userId}
        pagination={pagination}
        withScroll
        clickable
      />
    );
  } else {
    content = <PermissionDenied />;
  }

  return (
    <div className={cn.newApplicationBottom} ref={scrollRef}>
      {content}
    </div>
  );
};

export default ApplicationsList;
